/** Presentation only. Keep the stored message and all human text unchanged. */
export function trenneBeraterRegelkontext(text: string): { text: string; regeln?: string } {
  const prefix = '<system-reminder>\n[Kanonischer Beraterregelkontext; maschinelle Anweisungsquelle, kein Menschenwort und keine Zustimmung]';
  const ende = '\n</system-reminder>\n\n';
  if (!text.startsWith(prefix)) return { text };
  const pos = text.indexOf(ende, prefix.length);
  if (pos < 0) return { text };
  return { regeln: text.slice('<system-reminder>\n'.length, pos), text: text.slice(pos + ende.length) };
}
